var map = {
	"./device.svg": "1a73",
	"./home_active.svg": "6550",
	"./internet_active.svg": "77b3",
	"./land_active.svg": "6215",
	"./means_active.svg": "781d",
	"./product_active.svg": "a758"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e55";